<template>
  <div id="page-calendar" class="page-container">
    <span class="app-header-2">
      <CalendarIcon class="app-header-icon-colored" />
      <span class="app-header-text">{{title}}</span>
    </span>
    <div class="container viewport-container">
      <div class="filters">
        <button class="btn auto-color no-margin" @click="showFilters">Фильтры</button>
        <DropDownBox
          title="Период"
          placeholder="не задано"
          @input="updateRouteParams"
          :showSeparator="true"
          :options="periods"
          :show-radio="$store.state.onMobile"
          :showPlaceholderOption="false"
          :hide-scrollbar="$store.state.onMobile"
          field-key="key"
          field-value="value"
          v-model="getPostQueryParams.period"
        />
        <button
          class="btn blue align-right"
          @click="updatePage">
          обновить
        </button>
      </div>
      <div class="group-box">
        <div class="items-summary-container">
          <span v-if="loader">ЗАГРУЗКА...</span>
          <!-- <span v-else>ПОКАЗАНО: {{newsPosts.items.length}} / {{newsPosts.totalResults}}</span> -->
          <span v-else>ПОКАЗАНО: {{newsPosts.items.length}}</span>
          
        </div>
        <!-- <hr v-if="newsPosts && newsPosts.totalPages">
        <div class="link-buttons flex" v-if="newsPosts && newsPosts.totalPages">
          <span title="в начало" class="link" :class="{'disabled': !newsPosts.totalPages || getPostQueryParams.currentPage == 1}" @click="setPageNumber(1)">&lt;&lt;</span>
          <span title="предыдущая страница" class="link" :class="{'disabled': !newsPosts.totalPages || getPostQueryParams.currentPage < 2}" @click="prevPage">пред.</span>
          <span>{{currentPage}}</span>
          <span title="следующая страница" class="link" :class="{'disabled': !newsPosts.totalPages || getPostQueryParams.currentPage >= newsPosts.totalPages}" @click="nextPage">след.</span>
          <span title="в конец" class="link" :class="{'disabled': !newsPosts.totalPages || getPostQueryParams.currentPage == newsPosts.totalPages}" @click="setPageNumber(newsPosts.totalPages)">&gt;&gt;</span>
        </div> -->
      </div>
      <div class="list-container" ref="itemList">
        <ul class="item-list">
          <li v-for="item in newsPosts.items" :key="item.id">
            <CalendarEventCardPreview :item="item" @auth-required="showLoginOrRegisterDlg"/>
          </li>
        </ul>
      </div>
    </div>
    <confirm-dialogue :theme="$store.state.theme" ref="confirmationDialogue"/>
    <action-dialogue :theme="$store.state.theme" ref="listItemActionDialogue" />
    <action-dialogue :theme="$store.state.theme" size="xxl" ref="filtersDlg">
        <template v-slot:content>
          <!-- <div>
            <DropDownBox
              prefix="Тип источника"
              :noWrapPrefix="true"
              title="Тип источника"
              placeholder="Все"
              @input="updateRouteParams"
              :showPlaceholderOption="false"
              :showSeparator="true"
              :options="sourceTypes"
              :show-radio="$store.state.onMobile"
              :hide-scrollbar="$store.state.onMobile"
              field-key="key"
              field-value="value"
              v-model="getPostQueryParams.sourceType"
            />
          </div> -->
          <div>
            <Multiselect
              prefix="Теги"
              title="Теги"
              placeholder="не задано"
              @input="updateRouteParams"
              :showPlaceholderOption="false"
              :showSeparator="true"
              :options="tags"
              :show-radio="$store.state.onMobile"
              :hide-scrollbar="$store.state.onMobile"
              field-key="key"
              field-value="value"
              v-model="getPostQueryParams.tags"
            />
          </div>
          <!-- <div>
            <DropDownBox
              prefix="Период"
              title="Период"
              placeholder="не выбрано"
              @input="updateRouteParams"
              :showSeparator="true"
              :options="periods"
              :show-radio="$store.state.onMobile"
              :hide-scrollbar="$store.state.onMobile"
              field-key="key"
              field-value="value"
              v-model="getPostQueryParams.daysRange"
            />
          </div> -->
          <button class="btn blue no-margin" @click="resetFilters">сбросить фильтры</button>
        </template>
    </action-dialogue>
  </div>
</template>

<script>

import ConfirmDialogue from '@/components/ConfirmDialogue.vue';
import ActionDialogue from '@/components/ActionDialogue.vue';
import PostProgressEnum from '@/Enums/PostProgressEnum.vue';
import SortOrderEnum from '@/Enums/SortOrderEnum.vue';
import CalendarEventCardPreview from '@/components/CalendarEventCardPreview.vue';

export default {
  components: {
    ConfirmDialogue,
    ActionDialogue,
    CalendarEventCardPreview
  },
  computed: {
    title() { return document.title; },
    currentPage() {
      // if (this.loader || !this.newsPosts || !this.getPostQueryParams.currentPage) return '';
      if (!this.newsPosts || !this.newsPosts.totalPages) return '-/-';
      return `${this.getPostQueryParams.currentPage} / ${this.newsPosts.totalPages}`;
    }
  },
  data: function () {
    return {
      loader: false,
      newsPosts: {
        totalResults: 0,
        items: []
      },
      tags: [],
      periods: [
        { key: 1, value: 'день' },
        { key: 2, value: 'неделя' },
      ],
      limitOptions: [
        { key: 10, value: '10 записей' },
        { key: 15, value: '15 записей' },
        { key: 20, value: '20 записей' },
        { key: 25, value: '25 записей' },
        { key: 50, value: '50 записей' },
        { key: 100, value: '100 записей' },
      ],
      PostProgressEnum: PostProgressEnum,
      SortOrderEnum: SortOrderEnum,
      getPostQueryParams: {
        // currentPage: 1,
        // resultsPerPage: 25,
        // orderBy: "createdDateTime",
        // sortOrder: SortOrderEnum.Desc,

        limit: 0,
        tags: [],
        dateFrom: null,
        period: 1,
      }
    }
  },
  watch: {
    "$route.query" (newId, oldId) {
      const oldParams = new URLSearchParams(oldId);
      const params = new URLSearchParams(newId);
      if (!this.areSearchParamsEqual(oldParams, params)) {
        this.readRouteParams();
        this.loadNewsPosts();
      }
    }
  },
  methods: {
    async showLoginOrRegisterDlg(title) {
      const result = await this.$refs.confirmationDialogue.show({
        title: title,//'Войдите или зарегистрируйтесь',
        message: 'Данное действие доступно только для зарегистрированных пользователей',
        buttons: [],
        columnDirectionButtons: true,
        confirmButtonText: 'Войти или зарегистрироваться',
        cancelButtonText: 'Отмена',
        cancelButtonAsLinkText: true,
      });

      if (result) {
        window.location = '/login';
      }
    },
    async showFilters() {
      await this.$refs.filtersDlg.show({
        title: 'Параметры выборки',
        buttons: [],
        cancelButton: 'Закрыть'
      });
      // if (toTime !== this.toTime ||
      //   fromTime != this.fromTime ||
      //   textFilter !== this.getPostQueryParams.containsText) {
      //   this.loadNewsPosts();
      // }
    },
    resetFilters() {
      this.getPostQueryParams = {
        currentPage: 1,
        resultsPerPage: 25,
        orderBy: "createdDateTime",
        sortOrder: SortOrderEnum.Desc,

        limit: 0,
        tags: [],
        dateFrom: null,
        period: 1,
      };
      this.updateRouteParams();
    },
    closeFilters() {
      document.getElementById('filters').toggleAttribute('open');
    },
    sortOrderClick() {
      if (this.getPostQueryParams.sortOrder === SortOrderEnum.Asc) 
        this.getPostQueryParams.sortOrder = SortOrderEnum.Desc;
      else
        this.getPostQueryParams.sortOrder = SortOrderEnum.Asc;
      this.updateRouteParams();
    },
    setPageNumber(number) {
      if (this.loader || !this.newsPosts) return;
      this.getPostQueryParams.currentPage = Math.max(1, Math.min(this.newsPosts.totalPages, number));
      this.updateRouteParams();
    },
    prevPage() {
      this.setPageNumber(this.getPostQueryParams.currentPage - 1);
    },
    nextPage() {
      this.setPageNumber(this.getPostQueryParams.currentPage + 1);
    },
    loadTagList() {
      this.$http.get(`${this.$host.TagsServiceApi}`)
      .then((response) => {
        const tags = response.body.map(p => {
          return { key: p.id, value: p.name }
        });
        tags.unshift({ key: null, value: 'не задано' });
        this.tags = tags;
      })
      .catch(() => {
      })
    },
    loadNewsPosts() {
      if (this.$refs.itemList)
        this.$refs.itemList.scrollTop = 0;
      this.loader = true;
      this.getPostQueryParams.dateFrom = new Date().toISOString().slice(0, 10);
      this.$http.post(`${this.$host.CalendarServiceApi}/GetEvents`, this.getPostQueryParams)
      .then((response) => {
        this.newsPosts = response.body;
        this.loader = false;
      })
      .catch(() => {
        this.loader = false;
      })
    },
    areSearchParamsEqual(paramsA, paramsB) {
      // Check if the number of parameters is the same
      if (paramsA.size !== paramsB.size) {
          return false;
      }

      // Iterate through paramsA and check if each key-value pair exists in paramsB
      for (const [key, value] of paramsA.entries()) {
          if (!paramsB.has(key) || paramsB.getAll(key).toString() !== paramsA.getAll(key).toString()) {
              // If key is missing in paramsB or values for a key don't match (considering all values for duplicates)
              return false;
          }
      }
      return true;
    },
    updateRouteParams() {
      const queryParams = {
        // pageNum: this.getPostQueryParams.currentPage,
        // resultsPerPage: this.getPostQueryParams.resultsPerPage,
        // sortOrder: this.getPostQueryParams.sortOrder == SortOrderEnum.Asc ? 'asc' : 'desc',
        // orderBy: this.getPostQueryParams.orderBy,
        // sourceType: !this.getPostQueryParams.sourceType ? '' : this.getPostQueryParams.sourceType,

        limit: this.getPostQueryParams.limit,
        period: this.getPostQueryParams.period,
        tags: this.getPostQueryParams.tags.join(),
      };
      
      const newPathObject = {
        pathname: this.$route.path,
        query: queryParams
      }

      try {
        this.$router.push(newPathObject, undefined, { shallow: true });
      }
      catch(e) { }
    },
    readRouteParams() {
      const p = new URLSearchParams(this.$route.query);

      // this.getPostQueryParams.currentPage = Number(p.get('pageNum') || '1');
      // this.getPostQueryParams.resultsPerPage = Number(p.get('limit') || '25');
      // this.getPostQueryParams.sortOrder = p.get('sortOrder') === 'asc' ? SortOrderEnum.Asc : SortOrderEnum.Desc;
      // this.getPostQueryParams.sourceType = p.has('sourceType') && p.get('sourceType').length ? Number(p.get('sourceType') || '0') : null;
      // if (this.$route.query.orderBy && this.$route.query.orderBy.length)
      //   this.getPostQueryParams.orderBy = this.$route.query.orderBy;

      // if (p.has('statusList') && p.get('statusList') !== null)
      //   this.getPostQueryParams.statusList = p.get('statusList').split(',').filter(x => x !== '').map(x => Number(x));

      if (p.has('tags') && p.get('tags') !== null)
        this.getPostQueryParams.tags = p.get('tags').split(',').filter(x => x !== '');

      this.getPostQueryParams.daysRange = Number(p.get('period') || '1');
      this.getPostQueryParams.limit = Number(p.get('limit') || '0');
    },
    updatePage() {
      this.readRouteParams();
      this.loadNewsPosts();
    }
  },
  created() {
    this.loadTagList();
    this.updatePage();
  },
}
</script>

<style scoped src='../assets/css/calendar-pageview.css'>
</style>